import { FunctionComponent } from "react";

import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";

import { faFileCircleQuestion } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";
import { Tooltip } from "@/components/Tooltip/Tooltip";

/**
 * States, quietly, that a list holding hand-added leads has no source file of its own (PREC-4118).
 *
 * It sits *beside* the list's real status rather than replacing it: the list works, it simply
 * cannot be re-run, and the blue "Add source" call-to-action that used to stand in for the status
 * described a working list — 250 leads, live campaign, a reply already in — as unfinished. Muted
 * on purpose; this is a fact about the list, not a task the user has failed to do.
 */
export const ListNoFileHint: FunctionComponent<{ sourceStepUrl: string }> = ({ sourceStepUrl }) => {
	const { t } = useTranslation();

	return (
		<Tooltip content={t("list.noFile.tooltip")}>
			<Link
				className="flex cursor-pointer items-center text-xs font-medium text-text-meta hover:text-text"
				data-testid="list-no-file-hint"
				to={sourceStepUrl}
			>
				<Icon className="mr-1 w-3.5 h-3.5" icon={faFileCircleQuestion} />
				{t("list.noFile.label")}
			</Link>
		</Tooltip>
	);
};
